import { Controller } from "@hotwired/stimulus"

// Cascading content-group → tv-channel-list selects on import_jobs/new
export default class extends Controller {
  static targets = ["type", "tvChannelFields", "contentGroup", "tvChannelList"]

  connect() {
    this.toggleFields()
    this.element.addEventListener("submit", this.enableListBeforeSubmit)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.enableListBeforeSubmit)
  }

  enableListBeforeSubmit = () => {
    if (this.hasTvChannelListTarget) {
      this.tvChannelListTarget.disabled = false
    }
  }

  typeChanged() {
    this.toggleFields()
    this.resetListSelect()
  }

  contentGroupChanged() {
    this.resetListSelect()
    const contentGroupId = this.contentGroupTarget.value
    if (!contentGroupId) return

    fetch(`/content_groups/${contentGroupId}/tv_channel_lists`, {
      headers: { Accept: "application/json" }
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to load TV channel lists")
        return response.json()
      })
      .then((lists) => {
        lists.forEach((list) => {
          const option = document.createElement("option")
          option.value = list.id
          option.textContent = list.label
          this.tvChannelListTarget.appendChild(option)
        })
        this.tvChannelListTarget.disabled = lists.length === 0
      })
      .catch(() => {
        this.resetListSelect()
      })
  }

  toggleFields() {
    const isTvChannel = this.typeTarget.value === "tv_channel"
    this.tvChannelFieldsTarget.classList.toggle("d-none", !isTvChannel)
    this.contentGroupTarget.required = isTvChannel
    this.tvChannelListTarget.required = isTvChannel
    if (!isTvChannel) {
      this.contentGroupTarget.value = ""
      this.resetListSelect()
    }
  }

  resetListSelect() {
    this.tvChannelListTarget.innerHTML = ""
    const blank = document.createElement("option")
    blank.value = ""
    blank.textContent = "Select TV channel list..."
    this.tvChannelListTarget.appendChild(blank)
    this.tvChannelListTarget.disabled = true
  }
}
